<template>
  <div>
    <label
      :class="[$style.label, classNames.label]"
    >
      <input
        :checked="value === true"
        :class="[classNames.input, $style.inputPosition]"
        :disabled="disabled"
        :indeterminate.prop="indeterminate"
        :name="name"
        type="checkbox"
        @change="handleValueChange"
      >
      <!-- eslint-disable-next-line vue/no-v-html -->
      <span v-html="label.trim()" />
      <slot />
    </label>
    <IconTooltip
      v-if="tooltip && tooltip.text"
      :className="classNames.iconTooltipClassName"
      :iconClass="['jc-info-circle', $style.icon]"
    >
      <!-- eslint-disable-next-line vue/no-v-html -->
      <p v-html="tooltip.text" />
      <IconTooltipReadMore
        v-if="tooltip.kbLink"
        :kbLink="tooltip.kbLink"
        :kbLinkText="tooltip.kbLinkText"
      />
    </IconTooltip>
    <small
      v-if="labelSubText"
      :class="$style.labelSubText"
    >
      {{ labelSubText.trim() }}
    </small>
  </div>
</template>
<script>
// v-html is coming from BE, it should assumed that it is properly sanitized before being displayed
// if this component is utilized with FE requiring the v-html,
// it should be ensured there is NO user input in string
import IconTooltip from 'client/components/Tooltip/IconTooltip.vue';
import IconTooltipReadMore from 'client/components/Tooltip/IconTooltipReadMore.vue';

import TooltipPropMixin from 'client/components/FormValidation/mixins/TooltipPropMixin';

export default {
  name: 'CheckboxWithLabel',

  inject: ['$validator'],

  components: {
    IconTooltip,
    IconTooltipReadMore,
  },

  mixins: [
    TooltipPropMixin,
  ],

  model: {
    prop: 'value',
    event: 'change',
  },

  props: {
    classNames: {
      default: () => ({
        input: '',
        label: '',
      }),
      type: Object,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    handleChange: {
      default: () => {},
      type: Function,
    },
    indeterminate: {
      default: false,
      type: Boolean,
    },
    label: {
      default: '',
      type: String,
    },
    labelSubText: {
      default: '',
      type: String,
    },
    name: {
      default: '',
      type: String,
    },
    preventDefault: {
      default: false,
      type: Boolean,
    },
    tooltip: {
      type: Object,
      default() {
        return {
          kbLink: '',
          text: '',
          kbLinkText: '',
        };
      },
    },
    value: {
      required: true,
      type: Boolean,
    },
  },

  methods: {
    handleValueChange(event) {
      if (this.preventDefault) event.preventDefault();
      this.handleChange(event.target.checked);
      this.$emit('change', event.target.checked);
    },
  },
};
</script>
<style module>
@import '../FormValidation/css/formFields.css';

@value (fontHeight) from '~components/FormValidation/css/formFields.css';
@value (greyDark1) from '~css/colors.css';

.icon {
  font-size: fontHeight;
}

.label {
  display: inline !important;
  font-weight: normal !important;
}

.labelSubText {
  color: greyDark1;
  display: block;
  font-weight: 400;
  padding-left: 24px;
}
</style>
